import _defineProperty from "/usr/src/app/www/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _asyncToGenerator from "/usr/src/app/www/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _classCallCheck from "/usr/src/app/www/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/usr/src/app/www/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _inherits from "/usr/src/app/www/node_modules/@babel/runtime/helpers/esm/inherits.js";
import _possibleConstructorReturn from "/usr/src/app/www/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn.js";
import _getPrototypeOf from "/usr/src/app/www/node_modules/@babel/runtime/helpers/esm/getPrototypeOf.js";
import _regeneratorRuntime from "/usr/src/app/www/node_modules/@babel/runtime/regenerator/index.js";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
import { CompactEncrypt } from '../jwe/compact/encrypt.js';
import { encoder } from '../lib/buffer_utils.js';
import { ProduceJWT } from './produce.js';
export var EncryptJWT = /*#__PURE__*/function (_ProduceJWT) {
  _inherits(EncryptJWT, _ProduceJWT);
  var _super = _createSuper(EncryptJWT);
  function EncryptJWT() {
    _classCallCheck(this, EncryptJWT);
    return _super.apply(this, arguments);
  }
  _createClass(EncryptJWT, [{
    key: "setProtectedHeader",
    value: function setProtectedHeader(protectedHeader) {
      if (this._protectedHeader) {
        throw new TypeError('setProtectedHeader can only be called once');
      }
      this._protectedHeader = protectedHeader;
      return this;
    }
  }, {
    key: "setKeyManagementParameters",
    value: function setKeyManagementParameters(parameters) {
      if (this._keyManagementParameters) {
        throw new TypeError('setKeyManagementParameters can only be called once');
      }
      this._keyManagementParameters = parameters;
      return this;
    }
  }, {
    key: "setContentEncryptionKey",
    value: function setContentEncryptionKey(cek) {
      if (this._cek) {
        throw new TypeError('setContentEncryptionKey can only be called once');
      }
      this._cek = cek;
      return this;
    }
  }, {
    key: "setInitializationVector",
    value: function setInitializationVector(iv) {
      if (this._iv) {
        throw new TypeError('setInitializationVector can only be called once');
      }
      this._iv = iv;
      return this;
    }
  }, {
    key: "replicateIssuerAsHeader",
    value: function replicateIssuerAsHeader() {
      this._replicateIssuerAsHeader = true;
      return this;
    }
  }, {
    key: "replicateSubjectAsHeader",
    value: function replicateSubjectAsHeader() {
      this._replicateSubjectAsHeader = true;
      return this;
    }
  }, {
    key: "replicateAudienceAsHeader",
    value: function replicateAudienceAsHeader() {
      this._replicateAudienceAsHeader = true;
      return this;
    }
  }, {
    key: "encrypt",
    value: function () {
      var _encrypt = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(key, options) {
        var enc;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                enc = new CompactEncrypt(encoder.encode(JSON.stringify(this._payload)));
                if (this._replicateIssuerAsHeader) {
                  this._protectedHeader = _objectSpread(_objectSpread({}, this._protectedHeader), {}, {
                    iss: this._payload.iss
                  });
                }
                if (this._replicateSubjectAsHeader) {
                  this._protectedHeader = _objectSpread(_objectSpread({}, this._protectedHeader), {}, {
                    sub: this._payload.sub
                  });
                }
                if (this._replicateAudienceAsHeader) {
                  this._protectedHeader = _objectSpread(_objectSpread({}, this._protectedHeader), {}, {
                    aud: this._payload.aud
                  });
                }
                enc.setProtectedHeader(this._protectedHeader);
                if (this._iv) {
                  enc.setInitializationVector(this._iv);
                }
                if (this._cek) {
                  enc.setContentEncryptionKey(this._cek);
                }
                if (this._keyManagementParameters) {
                  enc.setKeyManagementParameters(this._keyManagementParameters);
                }
                return _context.abrupt("return", enc.encrypt(key, options));
              case 9:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));
      function encrypt(_x, _x2) {
        return _encrypt.apply(this, arguments);
      }
      return encrypt;
    }()
  }]);
  return EncryptJWT;
}(ProduceJWT);